import { render, staticRenderFns } from "./UndergraduateApplication.vue?vue&type=template&id=57f67c7c&scoped=true&"
import script from "./UndergraduateApplication.vue?vue&type=script&lang=js&"
export * from "./UndergraduateApplication.vue?vue&type=script&lang=js&"
import style0 from "./UndergraduateApplication.vue?vue&type=style&index=0&lang=less&"
import style1 from "./UndergraduateApplication.vue?vue&type=style&index=1&id=57f67c7c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f67c7c",
  null
  
)

export default component.exports